import * as I from 'immutable';

import {isCartEnabled} from 'app/modules/Cart';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';

import {ChatToolPermissions} from './toolCatalog';

/** Tools the catalog names but this organization and role cannot reach. */
export function unreachableChatTools(
  profile: I.ImmutableOf<ApiOrganizationUser> | null,
  organization: I.ImmutableOf<ApiOrganization> | null
): ReadonlySet<string> {
  return isCartEnabled(organization, profile) ? new Set() : new Set(['manage_cart']);
}

/**
 * The user's stored settings, with anything this organization and role cannot reach turned off.
 * The Worker drops a denied tool from the toolset, so the model is never offered a cart the user
 * has no way to open.
 */
export function chatToolPermissionsFor(
  profile: I.ImmutableOf<ApiOrganizationUser> | null,
  organization: I.ImmutableOf<ApiOrganization> | null
): ChatToolPermissions {
  const stored: ChatToolPermissions =
    profile?.getIn(['settings', 'chatToolPermissions'])?.toJS() ?? {};
  const denied = Object.fromEntries(
    [...unreachableChatTools(profile, organization)].map((name) => [name, 'denied' as const])
  );
  return {...stored, ...denied};
}
